export type LineType = 'landline' | 'wireless' | 'voip' | 'other';

export type LineTypeDetail =
  | 'landline' | 'mobile' | 'fixedVoip' | 'nonFixedVoip'
  | 'personal' | 'tollFree' | 'premium' | 'sharedCost'
  | 'uan' | 'voicemail' | 'pager' | 'unknown';

export interface ICCPhone {
  id: number;
  phone: string;
  line_type: LineType | null;
  line_type_detail: LineTypeDetail | null;
  carrier_name: string | null;
  lookup_date: string | null;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
}

export interface ICCPhoneResponse {
  data: ICCPhone[];
  total: number;
  per_page: number;
  current_page: number;
  last_page: number;
}

export class CCPhone {
  private id: number;
  private phone: string;
  private lineType: LineType | null;
  private lineTypeDetail: LineTypeDetail | null;
  private carrierName: string | null;
  private lookupDate: string | null;
  private createdAt: string;
  private updatedAt: string;
  private deletedAt: string | null;

  get Id(): number { return this.id }
  get Phone(): string { return this.phone }
  get LineType(): LineType | null { return this.lineType }
  get LineTypeDetail(): LineTypeDetail | null { return this.lineTypeDetail }
  get CarrierName(): string | null { return this.carrierName }
  get LookupDate(): string | null { return this.lookupDate }
  get CreatedAt(): string { return this.createdAt }
  get UpdatedAt(): string { return this.updatedAt }
  get DeletedAt(): string | null { return this.deletedAt }

  set LineType(v: LineType | null) { this.lineType = v }
  set LineTypeDetail(v: LineTypeDetail | null) { this.lineTypeDetail = v }
  set CarrierName(v: string | null) { this.carrierName = v }
  set LookupDate(v: string | null) { this.lookupDate = v }

  friendly(): string {
    const digits = this.phone.replace(/\D/g, '').slice(-10);
    if (digits.length === 10) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return this.phone;
  }

  constructor(data: ICCPhone) {
    this.id = data.id;
    this.phone = data.phone;
    this.lineType = data.line_type;
    this.lineTypeDetail = data.line_type_detail;
    this.carrierName = data.carrier_name;
    this.lookupDate = data.lookup_date;
    this.createdAt = data.created_at;
    this.updatedAt = data.updated_at;
    this.deletedAt = data.deleted_at;
  }

  static empty(): CCPhone {
    return new CCPhone({
      id: 0,
      phone: '',
      line_type: null,
      line_type_detail: null,
      carrier_name: null,
      lookup_date: null,
      created_at: '',
      updated_at: '',
      deleted_at: null,
    });
  }
}
